import { render, staticRenderFns } from "./MBTIresult.vue?vue&type=template&id=4d5d174f&scoped=true&"
import script from "./MBTIresult.vue?vue&type=script&lang=js&"
export * from "./MBTIresult.vue?vue&type=script&lang=js&"
import style0 from "./MBTIresult.vue?vue&type=style&index=0&id=4d5d174f&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d5d174f",
  null
  
)

export default component.exports